import { Redirect, Route } from "react-router";

// import useAuthState from "../hooks/AuthHooks/useAuthState";

const PrivateRoute = ({ authState, component: Component, ...rest }) => {
  // const [user, loading, error] = useAuthState(auth);
  // console.log(user);

  return (
    <Route
      {...rest}
      render={(props) =>
        authState ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
